import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { forwardRef as N, useContext as g } from "react";
import o from "classnames";
import W from "../Tooltip/index.js";
import { ThemeContext as C } from "../ThemeContext/index.js";
const S = "forma-ui__button__main", q = "forma-ui__button__secondary", L = "forma-ui__button__tertiary", P = "forma-ui__button__danger", j = "forma-ui__button__blue", B = "forma-ui__button__quaternary", R = "forma-ui__button__text", T = "forma-ui__button__textLight", z = "forma-ui__button__textPrimary", F = "forma-ui__button__shadow", U = "forma-ui__button__primary", X = "forma-ui__button__small", k = "forma-ui__button__medium", A = "forma-ui__button__extraSmall", D = "forma-ui__button__fullWidth", E = "forma-ui__button__disabled", G = "forma-ui__button__reversed", H = "forma-ui__button__icon", I = "forma-ui__button__tooltip", t = {
  main: S,
  secondary: q,
  tertiary: L,
  danger: P,
  blue: j,
  quaternary: B,
  text: R,
  textLight: T,
  textPrimary: z,
  shadow: F,
  primary: U,
  small: X,
  medium: k,
  extraSmall: A,
  fullWidth: D,
  disabled: E,
  reversed: G,
  icon: H,
  tooltip: I
}, J = N, K = (v, _) => {
  const { viewport: w } = g(C), {
    as: n = "button",
    className: m,
    size: a = "large",
    viewStyle: u = "primary",
    shadow: l,
    iconClassName: c,
    contentClassName: d,
    fullWidth: f,
    disabled: r,
    reversed: b,
    icon: s,
    children: i,
    type: p,
    title: h,
    ...y
  } = v;
  return h && w !== "phone" ? /* @__PURE__ */ e(
    W,
    {
      on: "hover",
      position: ["top center", "bottom center", "top left", "top right", "bottom left", "bottom right"],
      offsetX: 0,
      className: t.tooltip,
      control: /* @__PURE__ */ x(
        n,
        {
          className: o(
            t.main,
            t[u],
            a && t[a],
            l && t.shadow,
            f && t.fullWidth,
            r && t.disabled,
            b && t.reversed,
            m
          ),
          type: n === "button" ? p ?? "button" : void 0,
          disabled: r,
          ...y,
          ref: _,
          children: [
            s && /* @__PURE__ */ e("span", { className: o(t.icon, c), children: s }),
            i && /* @__PURE__ */ e("span", { className: o(t.content, d), children: i })
          ]
        }
      ),
      children: h
    }
  ) : /* @__PURE__ */ x(
    n,
    {
      className: o(
        t.main,
        t[u],
        a && t[a],
        l && t.shadow,
        f && t.fullWidth,
        r && t.disabled,
        b && t.reversed,
        m
      ),
      type: n === "button" ? p ?? "button" : void 0,
      disabled: r,
      ...y,
      ref: _,
      children: [
        s && /* @__PURE__ */ e("span", { className: o(t.icon, c), children: s }),
        i && /* @__PURE__ */ e("span", { className: o(t.content, d), children: i })
      ]
    }
  );
}, Z = J(K);
export {
  K as UnwrappedButton,
  Z as default
};
